import { CancelInterviewModal } from './CancelInterviewModal';

export default CancelInterviewModal;